export default __webpack_public_path__ + "static/media/feature-image.f4fa8b48.png";